const onlineUserIds = new Set();

function normalizeUserId(userId) {
    if (userId === null || userId === undefined || userId === '') return null;

    return String(userId);
}

export function isUserOnline(userId) {
    const normalizedUserId = normalizeUserId(userId);
    if (!normalizedUserId) return false;

    return onlineUserIds.has(normalizedUserId);
}

export function getOnlineUserIds() {
    return Array.from(onlineUserIds);
}

export function setUserPresence(userId, online) {
    const normalizedUserId = normalizeUserId(userId);
    if (!normalizedUserId) return null;

    if (online) {
        onlineUserIds.add(normalizedUserId);
    } else {
        onlineUserIds.delete(normalizedUserId);
    }

    return normalizedUserId;
}

export function replaceOnlineUsers(userIds = []) {
    const nextOnlineUserIds = new Set(userIds.map((userId) => normalizeUserId(userId)).filter(Boolean));
    const offlineUserIds = [];

    onlineUserIds.forEach((userId) => {
        if (!nextOnlineUserIds.has(userId)) {
            offlineUserIds.push(userId);
        }
    });

    onlineUserIds.clear();
    nextOnlineUserIds.forEach((userId) => onlineUserIds.add(userId));

    return {
        onlineUserIds: Array.from(nextOnlineUserIds),
        offlineUserIds,
    };
}

export function clearOnlineUsers() {
    const previousOnlineUserIds = Array.from(onlineUserIds);
    onlineUserIds.clear();

    return previousOnlineUserIds;
}
